
import { Service } from "./restService";

class UserService extends Service {

    addUser = (customerId, email, additionalData = {}, sendActivationMail = false) => {
        const url = `user?sendActivationMail=${sendActivationMail}`;

        const body = {
            authority: 'CUSTOMER_USER',
            customerId: {
                entityType: 'CUSTOMER',
                id: customerId,
            },
            email: email,
            ...additionalData
        }
        return this.POST(url, JSON.stringify(body))
            .then(response => response);
    }

    getActivationLink = (customerId) => {
        const url = `user/${customerId}/activationLink`;
        return this.GET(url)
            .then(response => {
                return response
            });
    }

    activateUser = (activateToken, password) => {
        const url = 'noauth/activate';
        const body = {
            activateToken: activateToken,
            password: password
        };
        return this.POST(url, JSON.stringify(body))
            .then(response => response);
    }


}

export default UserService;
export {
    UserService
}